import { render, staticRenderFns } from "./ITSBCGSQ.vue?vue&type=template&id=50a0892f&scoped=true"
import script from "./ITSBCGSQ.vue?vue&type=script&lang=js"
export * from "./ITSBCGSQ.vue?vue&type=script&lang=js"
import style0 from "./ITSBCGSQ.vue?vue&type=style&index=0&id=50a0892f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a0892f",
  null
  
)

export default component.exports